import { Component } from '@angular/core';
import {
    NavController,
    ModalController,
    LoadingController,
    ToastController,
    PopoverController,
    Events } from 'ionic-angular';

import { DataService } from '../../services/data';
import { UserService } from '../../services/user.service';
import { LocalStorageService } from '../../services/local-storage';
import { AlertMessager } from '../../lib/alertMessager';
import { EmailSearchPopover } from '../search/email-search';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
    selector: 'manage-staff',
    templateUrl: 'manage-staff.html'
})
export class ManageStaffPage {
    token: any;

    searchQuery: any = '';
    staffMembers: any = [];
    organizations: any = [];
    organizationId: number;
    producers: any = [];
    producerId: number;

    roles: any = [];

    popoverActive: boolean = false;
    saving: boolean = false;

    accountSelected: string = 'account:selected';
    accountSelectedHandler: any;
    accountSearchChangeObservable;

    constructor(public nav: NavController, public modal: ModalController, public loadingCtrl: LoadingController, private userService: UserService, 
                private data: DataService, private events: Events, private localStorage: LocalStorageService, private popoverCtrl: PopoverController,
                private toast: ToastController, private alertMessager: AlertMessager) {
        this.localStorage.getEntity('authtokens')
        .then(data => {
            this.token = data;
        });

        let loading = this.loadingCtrl.create({
            content: 'Retrieving Staff Members...'
        });

        loading.present();

        this.data.getStaffPageSettings()
        .then(settings => {
            this.organizations = (settings as any).organizations;
            this.producers = (settings as any).producers;
            this.roles = (settings as any).roles;
            this.roles.unshift({ id: -1, name: 'None'})

            this.organizationId = this.organizations[0].id;
            this.producerId = this.producers[0].id;

            this.getStaffMembers(loading);
        });
    }

	ionViewDidLoad() {
		this.accountSelectedHandler = (data) => {
			this.popoverActive = false;
			
			if (data === null)
				return;

            if ((data as any).roles == undefined)
                (data as any).roles = [];

            (data as any).roles.push( { organizationId: this.organizationId, producerId: this.producerId, roleId: 1 });
            (data as any).currentPrivilegeId = this.roles.filter(y => y.id == 1)[0].id;
            this.staffMembers.push(data);
		};

		this.events.subscribe(this.accountSelected, this.accountSelectedHandler);
	}

	ionViewWillUnload() {
		this.events.unsubscribe(this.accountSelected, this.accountSelectedHandler);
	}

    onSearchChange(searchEvent, searchValue : string) {	
        if (!this.accountSearchChangeObservable) {
            Observable.create(observer => {
                this.accountSearchChangeObservable = observer;
            }).debounceTime(400)
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.userSearchPopover(searchEvent, searchValue) });
        }
		
		this.accountSearchChangeObservable.next(searchValue);
	}

    getStaffMembers(loading) {
        if (loading == null || loading == undefined) {            
            loading = this.loadingCtrl.create({
                content: 'Retrieving Staff Members...'
            });

            loading.present();
        }
        
        this.data.getStaffMembers(this.organizationId, this.producerId)
        .then(staffMembers => {
            this.staffMembers = (staffMembers as any).filter(x => x.id !== this.token.id);
            this.staffMembers = (staffMembers as any).filter(x => x.roles.filter(y => y.privilegeId == 6).length == 0);

            for (let i = 0; i < this.staffMembers.length; i++) {
                this.staffMembers[i].currentPrivilegeId = this.roles.filter(y => y.id == this.staffMembers[i].roles.filter(x => x.organizationId == this.organizationId && x.producerId == this.producerId)[0].privilegeId)[0].id;
            }

            loading.dismiss();
        }, error => {
            loading.dismiss();
            this.alertMessager.showError("Retrieving Staff Members Error", error);
        });
    }

	userSearchPopover(event, searchValue : string) {
		if (this.popoverActive)
			return;

		this.popoverActive = true;

        this.data.getStaffSearch(searchValue)
        .then(data => {
			let popover = this.popoverCtrl.create(EmailSearchPopover, {
                callback: this.accountSelected,
                staff: true,
				results: data,
				searchValue: searchValue
			});
		
			popover.present({ ev: event});
        })
        .catch(error => this.alertMessager.showError('Error', 'Unable to retrieve search results: ' + error));
	}

    saveChanges() {
        if (this.saving)
            return;

        this.saving = true;

        for (let i = 0; i < this.staffMembers.length; i++) {
            for (let j = 0; j < this.staffMembers[i].roles.length; j++) {
                if (this.staffMembers[i].roles[j].organizationId == this.organizationId && this.staffMembers[i].roles[j].producerId == this.producerId) {

                    if (this.staffMembers[i].currentPrivilegeId == 0)
                        this.staffMembers[i].roles = this.staffMembers[i].roles.filter(x => x.id !== (this.staffMembers[i].roles[j].id));
                    else
                        this.staffMembers[i].roles[j].roleId = this.staffMembers[i].currentPrivilegeId;
                }
            }
        }

        this.userService.updateStaffAccounts(this.staffMembers)
        .then(staffMembers => {
            if ((staffMembers as any).errorMessage != undefined) {
                this.alertMessager.showError("Saving Roles Error", (staffMembers as any).errorMessage);
            } else {
                this.staffMembers = (staffMembers as any).filter(x => x.id !== this.token.id);

                console.log("staffMembers: ", this.staffMembers);
                for (let i = 0; i < this.staffMembers.length; i++) {
                    this.staffMembers[i].currentPrivilegeId = this.roles.filter(y => y.id == this.staffMembers[i].roles.filter(x => x.organizationId == this.organizationId && x.producerId == this.producerId)[0].privilegeId)[0].id;
                }

                const toast = this.toast.create({
                    message: "Successfully saved roles.",
                    duration: 3000,
                    position: 'bottom',
                });
    
                toast.present();
            }

            this.saving = false;
        }, error => {
            this.alertMessager.showError("Saving Roles Error", error);
            this.saving = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/manage/manage-staff.ts